module.exports = __webpack_public_path__ + "static/media/stop-circle.e654ba1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/stop-circle.svg
// module id = 858
// module chunks = 0